"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgCheckIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M24.477 4.094c.697.698.697 1.83 0 2.528L10.193 20.906a1.79 1.79 0 0 1-2.528 0L.523 13.764a1.788 1.788 0 0 1 2.528-2.528l5.88 5.876L21.956 4.094a1.79 1.79 0 0 1 2.527 0z' }) })));
});
exports.default = (0, react_1.memo)(SvgCheckIcon);
